<template>
    <h4 style="text-align:center;margin:20px">{{ this.$t('thankYouForPurchase') }}</h4>
</template>

<script>
export default {
    mounted() {
        const checkoutPage = new BroadcastChannel('checkout')
        checkoutPage.postMessage({type: "checkout_finished"})
    }
}
</script>